import Vue from 'vue'
import VueRouter from 'vue-router'
import Login from '../view/Login'
import Register from '../view/Register'
import ResetPwd from '../view/ResetPwd.vue'
import Visitors from '../view/Visitors.vue'
import ErrorView from '../view/ErrorView.vue'
// 安装路由
Vue.use(VueRouter);

// 配置导出路由
const router = new VueRouter({
  routes: [{
    path: "/",
    redirect: "/visitors/chat"
  },
  {
    name: "ErrorView",
    path: '/error',
    component: ErrorView
  },
  // {
  //   name: "Login",
  //   path: '/login',
  //   component: Login
  // },
  {
    name: "Register",
    path: '/register',
    component: Register
  },
  {
    name: "ResetPwd",
    path: '/password/reset',
    component: ResetPwd
  },
  {
    name: "Visitors",
    path: '/visitors',
    component: Visitors,
    children: [
      {
        name: "Chat",
        path: "/visitors/chat",
        component: () => import("../view/Chat"),
      },
      {
        name: "Friend",
        path: "/visitors/friend",
        component: () => import("../view/Friend"),
      },
      {
        name: "GROUP",
        path: "/visitors/group",
        component: () => import("../view/Group"),
      },
      {
        name: "Setting",
        path: "/visitors/setting",
        component: () => import("../view/Setting"),
      }
    ]
  }
  ]
});

export default router;